module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.product && _vm.loading) ? _c('loader', {
    attrs: {
      "loading": true,
      "fixed": true
    }
  }) : _vm._e(), _vm._v(" "), (_vm.product) ? _c('main', {
    staticClass: "center full"
  }, [(_vm.isDisplay) ? _c('WishList') : _vm._e(), _vm._v(" "), (_vm.$route.query.refere === 'basket') ? _c('div', {
    staticClass: "backBasket"
  }, [_c('router-link', {
    staticClass: "backBasket-link pointer",
    attrs: {
      "tag": "span",
      "to": '/basket/basket-list-items/' + _vm.urlReferrer.params.id
    }
  }, [_c('i', {
    staticClass: "fas fa-angle-double-left fa-1x"
  }), _vm._v(" " + _vm._s(_vm.$t("basket.back")) + "\n            ")])], 1) : _vm._e(), _vm._v(" "), (_vm.product !== 'empty') ? _c('section', {
    staticClass: "flexContainer fd-c full",
    attrs: {
      "id": "produit"
    }
  }, [_c('p', {
    staticClass: "back pointer",
    on: {
      "click": function($event) {
        _vm.goPrev()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/back.png"),
      "width": "21",
      "alt": ""
    }
  }), _vm._v(" " + _vm._s(_vm.$t("contentPage.backToSearch")))]), _vm._v(" "), _c('section', {
    attrs: {
      "id": "produitWrapper"
    }
  }, [_c('div', {
    staticClass: "content-product rel"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('loader', {
    attrs: {
      "loading": _vm.loading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-md-3"
  }, [_c('ComponentPreview', {
    attrs: {
      "component": _vm.product,
      "imageId": _vm.selectedImageId
    },
    on: {
      "click": _vm.openZoomer
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "smallImgContainer"
  }, _vm._l((_vm.orderedFiguresAdvances), function(image) {
    return _c('div', {
      key: image.id,
      staticClass: "figuresList",
      attrs: {
        "id": "smallPic"
      },
      on: {
        "click": function($event) {
          _vm.selectedImageId = image.id
        }
      }
    }, [_c('img', {
      staticClass: "otherPhoto pointer",
      attrs: {
        "src": _vm.getImgPathFig(image.small, 'small'),
        "id": 'smallPhoto' + image.small,
        "alt": ""
      }
    })])
  })), _vm._v(" "), (_vm.product.config != null) ? _c('div', {
    staticClass: "configurationLog"
  }, [(_vm.product.createConfigAt) ? _c('p', [_vm._v("\n                                    " + _vm._s(_vm.$t("component.moduleConfifured")
    .replace("{user}", _vm.fullNameFormat(_vm.product.createConfigBy))
    .replace("{date}", _vm.product.createConfigAt)) + "\n                                ")]) : _vm._e(), _vm._v(" "), (_vm.product.modifiedConfigBy) ? _c('p', [_vm._v("\n                                    " + _vm._s(_vm.$t("component.moduleLastModified")
    .replace("{user}", _vm.fullNameFormat(_vm.product.modifiedConfigBy))
    .replace("{date}", _vm.product.modifiedConfigAt)) + "\n                                ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flexContainer actions"
  }, [(_vm.product.type.name === 'module' && _vm.configuratorAble() && _vm.hasAccessBothAdmin()) ? _c('router-link', {
    staticClass: "btn pointer uppercase configurateur",
    attrs: {
      "to": {
        name: 'Configurator'
      },
      "exact": "",
      "tag": "button"
    }
  }, [_vm._v(_vm._s(_vm.$t("component.configurator")))]) : _vm._e(), _vm._v(" "), (_vm.showImageEditor) ? _c('router-link', {
    staticClass: "btn pointer uppercase",
    attrs: {
      "tag": "button",
      "to": {
        name: 'ProductImgEditor'
      },
      "exact": ""
    }
  }, [_vm._v(_vm._s(_vm.$t("component.imgEditor")))]) : _vm._e(), _vm._v(" "), (_vm.hasEditorRoute && _vm.hasAccessBothAdmin()) ? _c('router-link', {
    staticClass: "btn pointer uppercase",
    attrs: {
      "to": _vm.editorRoute,
      "exact": "",
      "tag": "button"
    }
  }, [_vm._v(_vm._s(_vm.$trad.configurator.label))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6"
  }, [_c('div', {
    staticClass: "flexContainer jc-sb",
    attrs: {
      "id": "titleProduit"
    }
  }, [_c('div', {
    staticClass: "bloc-title"
  }, [(_vm.product.is_published === false) ? _c('span', {
    staticClass: "published"
  }, [_vm._v("[" + _vm._s(_vm.$t("component.notPublished")) + "]")]) : _vm._e(), _vm._v(" "), _c('hr', {
    staticClass: "clear"
  }), _vm._v(" "), (_vm.product.terms.hasOwnProperty('name')) ? _c('span', {
    staticClass: "uppercase bold titleComponent"
  }, [_vm._v("\n                                        " + _vm._s((_vm.product.type.name === "fascia" && _vm.product.config ?
    ((_vm.product.config.width) + " x " + (_vm.product.config.height) + " ") :
    "") + _vm.getTranslate(_vm.product.terms.name)) + "\n                                    ")]) : _vm._e(), _vm._v(" "), (_vm.product && _vm.product.standDesign) ? _c('div', {
    staticClass: "uppercase titleComponent"
  }, [_vm._v("\n                                        " + _vm._s(_vm.product.standDesign.name) + "\n                                    ")]) : _vm._e(), _vm._v(" "), _c('hr', {
    staticClass: "clear"
  }), _vm._v(" "), (_vm.product.status) ? _c('div', {
    staticClass: "ff-light uppercase statusTitle blocBtn",
    style: ({
      backgroundColor: _vm.getStatusColor(_vm.product.status.name)
    })
  }, [_vm._v("\n                                        " + _vm._s(_vm.getTranslate(_vm.product.status.terms.name)) + "\n                                    ")]) : _vm._e(), _vm._v(" "), (_vm.product.campaigns !== null && _vm.product.campaigns.launch) ? _c('div', {
    staticClass: "ff-light uppercase blocBtn"
  }, [_vm._v("\n                                        " + _vm._s(_vm.$t("product.launch")) + ": " + _vm._s(_vm.product.campaigns.launch.name) + "\n                                        "), (_vm.product.campaigns.discontinued.name) ? _c('span', [_c('br'), _vm._v("\n                                            " + _vm._s(_vm.$t("product.discontinued")) + ": " + _vm._s(_vm.product.campaigns.discontinued.name) + "\n                                        ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (
    _vm.hasAccessValidate(((_vm.product.type.name) + "_manager"), [
      _vm.APPLICATION.FORECAST_ID,
      _vm.APPLICATION.CATALOG_FORECAST_ID
    ])
  ) ? _c('div', [_c('span', {
    staticClass: "publish txtCenter"
  }, [_vm._v(_vm._s(_vm.$t("product.publish")))]), _vm._v(" "), _c('label', {
    staticClass: "switch flexContainer",
    on: {
      "change": function($event) {
        _vm.publish()
      }
    }
  }, [_c('div', {
    staticClass: "flexContainer"
  }, [(_vm.product.is_published === false) ? _c('input', {
    attrs: {
      "id": "publishedButton",
      "type": "checkbox"
    }
  }) : _c('input', {
    attrs: {
      "id": "publishedButton",
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "slider round"
  })])])]) : _vm._e(), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "export-pdf-product"
  }, [_c('h3', {
    staticClass: "ff-medium rel flexContainer jc-sb btnExportPDF"
  }, [(
    (_vm.product.type.name === 'module' || _vm.product.type.name === 'product') &&
    _vm.product.type.name != 'artwork' &&
    _vm.product.type.name != 'accessory' &&
    _vm.product.type.name != 'peel-off'
  ) ? _c('span', {
    staticClass: "mobileNot exportPDFCat iLineBlock",
    on: {
      "click": function($event) {
        _vm.openPdf()
      }
    }
  }, [_c('ExportPdfSvg')], 1) : _vm._e(), _vm._v(" "), _c('span', {
    key: _vm.product.isStar,
    on: {
      "click": function($event) {
        _vm.addStar(_vm.product.id)
      }
    }
  }, [_c('i', {
    staticClass: "fa-star fa-2x pointer",
    class: _vm.product.isStar ? 'fas' : 'far',
    style: (_vm.starStyle)
  })]), _vm._v(" "), (_vm.showpopin) ? _c('div', {
    staticClass: "msgPDFCat"
  }, [_c('div', {
    staticClass: "arrow"
  }), _vm._v("\n                                            " + _vm._s(_vm.$t("product.errorCompagn")) + "\n                                        ")]) : _vm._e()])])]), _vm._v(" "), (_vm.infosDisplay) ? _c('div', {
    staticClass: "infoProduitContent",
    attrs: {
      "id": "infoProduitContent"
    }
  }, [_c('ul', {
    staticClass: "uppercase listNone flexContainer jc-sa m-fd-c t-fd-c txtCenter"
  }, [_c('li', {
    staticClass: "tab active bold"
  }, [_vm._v(_vm._s(_vm.$t("product.articleInfos")))])]), _vm._v(" "), _c('table', {
    staticClass: "table product-table table-striped table-sm table-borderless"
  }, [_c('tbody', [(_vm.hasAccessRead('plano_builder')) ? _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t("component.typeComponentForPlano")))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.product.type.terms.name[_vm.$t("trad")]))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.categoryHierarchy), function(n, key) {
    return _c('tr', {
      key: ("categoriesArb_" + key)
    }, [_c('td', {
      staticClass: "ff-medium m-w-mid vMid"
    }, [_vm._v(_vm._s(_vm.$t("component.categories")) + " " + _vm._s(key + 1))]), _vm._v(" "), _c('td', {
      staticClass: "m-w-mid vMid"
    }, [_vm._v(_vm._s(n.map(function (element) { return element.name[_vm.$t("trad")]; }).join(" / ")))])])
  }), _vm._v(" "), _vm._l((_vm.product.infosArticle), function(info, key) {
    return (info.componentProperty.value !== '') ? _c('tr', {
      key: info.id
    }, [(key.toLowerCase() != 'categories' && _vm.product.type.name != 'artwork') ? _c('td', {
      staticClass: "ff-medium m-w-mid vMid"
    }, [_vm._v("\n                                                " + _vm._s(info.componentProperty.terms.name[_vm.$t("trad")]["value"]) + "\n                                            ")]) : _vm._e(), _vm._v(" "), (key.toLowerCase() != 'categories') ? _c('td', {
      staticClass: "m-w-mid vMid"
    }, [_vm._v("\n                                                " + _vm._s(info.componentProperty.value) + "\n                                            ")]) : _vm._e()]) : _vm._e()
  }), _vm._v(" "), (_vm.cogsProperty && _vm.cogsProperty.value !== '') ? _c('tr', [(_vm.product.type.name !== 'artwork') ? _c('td', {
    staticClass: "ff-medium m-w-mid vMid"
  }, [_vm._v("\n                                                " + _vm._s(_vm.cogsProperty.terms.name[_vm.$t("trad")]["value"]) + "\n                                            ")]) : _vm._e(), _vm._v(" "), _c('td', {
    staticClass: "m-w-mid vMid"
  }, [_vm._v("\n                                                " + _vm._s(parseFloat(_vm.cogsProperty.value).toFixed(2)) + " " + _vm._s(_vm.getBrand.currency.symbol) + "\n                                            ")])]) : _vm._e(), _vm._v(" "), (_vm.hasAccessRead('plano_builder')) ? _c('tr', [_c('td', {
    staticClass: "ff-medium m-w-mid vMid"
  }, [_vm._v(_vm._s(_vm.$t("component.nickname")))]), _vm._v(" "), (
    _vm.product.terms.hasOwnProperty('nickname') && _vm.product.terms.nickname.hasOwnProperty(_vm.$t('trad'))
  ) ? _c('td', [_vm._v("\n                                                " + _vm._s(_vm.product.terms.nickname[_vm.$t("trad")]["value"]) + "\n                                            ")]) : _c('td', [_vm._v(_vm._s(_vm.product.nickname))])]) : _vm._e(), _vm._v(" "), (_vm.product.comment !== null) ? _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t("catalogue.comment")))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.product.comment))])]) : _vm._e()], 2)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "infoProduitContent"
  }, [_c('ul', {
    staticClass: "uppercase listNone flexContainer jc-sa m-fd-c t-fd-c txtCenter"
  }, [_c('li', {
    staticClass: "tab active bold"
  }, [_vm._v(_vm._s(_vm.$t("product.zoneCampaignInfos")))])]), _vm._v(" "), _c('table', {
    staticClass: "table table-striped table-sm table-borderless"
  }, [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "align": "left",
      "scope": "col"
    }
  }, [_vm._v("ZONES")]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "left",
      "scope": "col"
    }
  }, [_vm._v(_vm._s(_vm.$t("campaign.from")))]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "left",
      "scope": "col"
    }
  }, [_vm._v(_vm._s(_vm.$t("campaign.to")))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.orderedZones), function(zone) {
    return _c('tr', {
      key: zone.id
    }, [_c('td', {
      staticClass: "uppercase"
    }, [_vm._v("\n                                                    " + _vm._s(zone.zone.name) + " "), (_vm.isDisabledZone(zone.zone.id)) ? _c('span', [_c('i', [_vm._v("(Deleted)")])]) : _vm._e()]), _vm._v(" "), (zone.campaign !== null) ? _c('td', [_vm._v(_vm._s(zone.campaign.name))]) : _vm._e(), _vm._v(" "), _c('td', [(zone.discontinuedCampaign) ? _c('span', [_vm._v(_vm._s(zone.discontinuedCampaign.name))]) : _c('span', [_vm._v(" " + _vm._s(_vm.$t("campaign.notDiscontinued")))])])])
  }))])]), _vm._v(" "), (_vm.canDeleteComponent) ? _c('button', {
    staticClass: "btn uppercase pointer ff-light btnDelete fleft",
    attrs: {
      "id": "delete"
    },
    on: {
      "click": function($event) {
        _vm.deleteItem()
      }
    }
  }, [_vm._v("\n                                    " + _vm._s(_vm.$t("common.delete")) + "\n                                ")]) : _vm._e(), _vm._v(" "), (_vm.canUpdateComponent) ? _c('router-link', {
    staticClass: "btn uppercase pointer ff-light btnEdit fleft",
    attrs: {
      "to": ("/components/" + (_vm.product.id) + "/edit")
    }
  }, [_vm._v("\n                                    " + _vm._s(_vm.$t("common.edit")))]) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-md-3"
  }, [(
    _vm.product.price != null && _vm.displayRealPrice(_vm.product.price, _vm.product.priceShown, true) && _vm.product.price.currency
  ) ? _c('h3', [_vm._v("\n                                " + _vm._s(_vm.$t("basket.shippingPrice").replace(
    "{price}",
    _vm.currencyCustomPipe(_vm.product.price.value, "en-US", _vm.product.price.currency.shortName)
  )) + "\n                            ")]) : _vm._e(), _vm._v(" "), (
    _vm.product.price != null &&
    _vm.product.type.name !== 'product' && // is basket
    _vm.hasAccessRead('orders_manager') &&
    (_vm.product.eStoreType != 1 || (_vm.product.eStoreType == 2 && _vm.hasAccessBothAdmin()))
  ) ? _c('AddToBasket') : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.product.type.name === 'module' || _vm.product.type.name === 'product') ? _c('div', {
    staticClass: "pointer",
    staticStyle: {
      "background-color": "rgba(52, 52, 52, 0.45)",
      "height": "50px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.addWishList(_vm.product)
      }
    }
  }, [_c('img', {
    staticStyle: {
      "padding-left": "12px",
      "margin-top": "7px"
    },
    attrs: {
      "src": require("../../../static/img/pdf_icon_2.svg"),
      "alt": "",
      "height": "35"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fright addBook",
    staticStyle: {
      "padding-right": "28px",
      "margin-top": "16px",
      "color": "#fff"
    }
  }, [_vm._v("ADD TO A PDF BOOK")])]) : _vm._e(), _vm._v(" "), (_vm.hasAccessForecastItemManager) ? _c('ForecastItemManager', {
    attrs: {
      "item": _vm.product
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [(_vm.hasAccessForecastItemSummary) ? _c('ItemForecast', {
    attrs: {
      "itemId": _vm.product.id
    }
  }) : _vm._e()], 1)]), _vm._v(" "), (_vm.product.type.name === 'product') ? _c('teinte') : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('Related'), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.product.type.name === 'module') ? _c('TicketStrip') : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "createBy"
  }, [_c('span', {
    staticClass: "fright"
  }, [_vm._v("\n                    " + _vm._s(_vm.$t("planobuilder.by")) + " " + _vm._s(_vm.product.createdUser.firstname) + " " + _vm._s(_vm.product.createdUser.lastname) + "\n                    " + _vm._s(_vm.$t("planobuilder.on")) + " " + _vm._s(_vm.product.createdUser.dateCreated) + "\n                    "), (_vm.product.modifiedUser !== null) ? _c('span', [_vm._v("\n                        - " + _vm._s(_vm.$t("planobuilder.modifiedBy")) + " " + _vm._s(_vm.product.modifiedUser.firstname) + " " + _vm._s(_vm.product.modifiedUser.lastname) + "\n                        " + _vm._s(_vm.$t("planobuilder.on")) + " " + _vm._s(_vm.product.modifiedUser.modifiedDate) + "\n                    ")]) : _vm._e()])])], 1) : _vm._e(), _vm._v(" "), (_vm.product === 'empty') ? _c('section', {
    staticClass: "flexContainer fd-c full"
  }, [_c('div', {
    staticClass: "flexContainer noComponentDiv"
  }, [_c('h2', {
    staticClass: "noComponent txtCenter uppercase"
  }, [_vm._v(_vm._s(_vm.$t("product.noComponent")))])])]) : _vm._e(), _vm._v(" "), _c('Modal', {
    attrs: {
      "action": _vm.dataAction
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d220503","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/product/Component.vue
// module id = 3098
// module chunks = 0